import { AssetTerminal } from "@/components/asset-terminal";
import { Heartbeat } from "@/components/heartbeat";
import { Hero } from "@/components/hero";
import { HowPullWorks } from "@/components/how-pull-works";
import { IntegrationBlock } from "@/components/integration-block";
import { LatencyTape } from "@/components/latency-tape";
import { LatencyThesis } from "@/components/latency-thesis";
import { SiteFooter } from "@/components/site-footer";
import { TrustDashboard } from "@/components/trust-dashboard";
import { UseCases } from "@/components/use-cases";
import { PricesProvider } from "@/lib/prices-context";

export function App() {
  return (
    <PricesProvider>
      <a
        href="#main"
        className="absolute left-4 -top-32 z-50 rounded border border-emerald bg-bg-deep px-3 py-2 font-mono text-xs uppercase tracking-[0.18em] text-emerald focus:top-4 transition-all"
      >
        Skip to content
      </a>

      <div className="relative min-h-screen overflow-hidden">
        {/* Subtle radial depth toward the bottom of the viewport. */}
        <div
          aria-hidden
          className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_120%,rgba(127,255,140,0.06),transparent_70%)]"
        />
        {/* Faint film grain via inline SVG — gives surfaces texture without a network image. */}
        <div
          aria-hidden
          className="pointer-events-none fixed inset-0 opacity-[0.025] mix-blend-overlay"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
          }}
        />

        <SiteHeader />
        <Heartbeat />

        <main id="main">
          <Hero />
          <HowPullWorks />
          <AssetTerminal />
          <LatencyThesis />
          <UseCases />
          <IntegrationBlock />
          <TrustDashboard />
        </main>

        <SiteFooter />
        <LatencyTape />
      </div>
    </PricesProvider>
  );
}

function SiteHeader() {
  return (
    <header className="relative z-20 flex items-center justify-between px-6 py-5 sm:px-10 sm:py-6">
      <a
        href="/"
        className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.32em] text-text"
        aria-label="Noeracle home"
      >
        <span className="size-1.5 rounded-full bg-emerald shadow-[0_0_8px_rgba(127,255,140,0.55)]" />
        NOERACLE
      </a>
      <nav
        className="flex items-center gap-6 font-mono text-[10px] uppercase tracking-[0.22em] text-m55"
        aria-label="Primary"
      >
        <a
          className="hover:text-emerald transition-colors"
          href="https://docs.noeracle.org"
          target="_blank"
          rel="noopener"
        >
          Docs
        </a>
        <a className="hover:text-emerald transition-colors" href="/status/">Status</a>
        <a
          className="hover:text-emerald transition-colors"
          href="https://www.npmjs.com/package/@noeracle/sdk"
          rel="noopener"
        >
          npm
        </a>
        <a
          className="hover:text-emerald transition-colors"
          href="https://github.com/noeracle/noeracle"
          rel="noopener"
        >
          GitHub
        </a>
      </nav>
    </header>
  );
}
